import { c as _c } from "react/compiler-runtime";
import { ArrowButton } from "@website/accommodation-ui/price-calendar-wrapper/arrow-button";
import { usePriceCalendar } from "@website/accommodation-ui/price-calendar-wrapper/hooks";
import { PriceBox } from "@website/accommodation-ui/price-calendar-wrapper/price-box/price-box";
import { PriceCalendarProperties } from "@website/accommodation-ui/price-calendar-wrapper/types";
import "keen-slider/keen-slider.min.css";
import { FC } from "react";
const sliderClassNames = "keen-slider size-full";
export const PriceCalendarDesktop: FC<PriceCalendarProperties> = properties => {
  const $ = _c(21);
  const {
    list,
    sliderWrapper,
    slider,
    listTranslate,
    onBackwardClicked,
    onForwardClicked,
    isForwardDisabled,
    isBackwardDisabled
  } = usePriceCalendar(properties);
  let t0;
  if ($[0] !== isBackwardDisabled || $[1] !== onBackwardClicked) {
    t0 = <ArrowButton disabled={isBackwardDisabled} onClick={onBackwardClicked} type="right" />;
    $[0] = isBackwardDisabled;
    $[1] = onBackwardClicked;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = `translateX(${listTranslate}px)`;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      transform: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== list) {
    t3 = list?.map(_temp);
    $[5] = list;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== sliderWrapper || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex transition-all" ref={sliderWrapper} style={t2}>{t3}</div>;
    $[7] = sliderWrapper;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== slider || $[12] !== t4) {
    t5 = <section className={`${sliderClassNames} size-full`} ref={slider}>{t4}</section>;
    $[11] = slider;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isForwardDisabled || $[15] !== onForwardClicked) {
    t6 = <ArrowButton disabled={isForwardDisabled} onClick={onForwardClicked} type="left" />;
    $[14] = isForwardDisabled;
    $[15] = onForwardClicked;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t0 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex w-full flex-row gap-2">{t0}{t5}{t6}</div>;
    $[17] = t0;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(item, index) {
  return <PriceBox key={index} {...item} />;
}